import { render, staticRenderFns } from "./AddServiceProfile.vue?vue&type=template&id=aa8a7484&"
import script from "./AddServiceProfile.vue?vue&type=script&lang=js&"
export * from "./AddServiceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports